module.exports = __webpack_public_path__ + "static/media/CCRO_new_header.cd7b5def.png";